import BaseComponent from "./BaseComponent";

export default class Switch extends BaseComponent {
    /**
     * On/off toggle style checkbox
     * @module Switch
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
        this.state = {
            checked: this.props.hasOwnProperty("checked") && this.props.checked,
            disabled: this.props.hasOwnProperty("disabled") && this.props.disabled
        };
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.disabled !== this.state.disabled){
            this.setState({disabled: nextProps.disabled});
        }
        if(nextProps.checked !== this.state.checked){
            this.setState({checked: nextProps.checked});
        }    
    }

    /**
     * Get toggle label
     * @returns {string}
     */
    getLabel(){
        const label =  (this.state.checked) ? (this.props.toggledLabel) ? this.props.toggledLabel 
            : this.props.label 
            : this.props.label;
            //CORE-30624 - all switches with labels will use the same CSS as Domain Fallback for tooltip
            if(this.props.label){
                return(
                    <span data-tip={this.props.tooltip}>{label}{(this.props.tooltip) ? <i className="fe icon-info"/> : ''}</span>
                );
            }
    }

    /**
     * Handle mouse click
     */
    handleClick(){
        if (this.state.disabled){
            if(this.props.callback){
                this.props.callback();
            }
            return;
        }
        const newVal = !this.state.checked;
        if (this.props.valKey === "externalAudioPrompt") {
            const {type, idx} = this.props;
            this.updateContext({ value:newVal, type, idx  });
            this.toggle(newVal);
            this.props.fillertoggle(newVal);
        }
        else {
            
            if(this.props.callback){
                window.apm.setSerializedChanged();
                this.props.callback();
            }
            
            this.toggle(newVal);
            this.updateContext(newVal, this.toggle(newVal));
        }

        if(this.props.broadcast) {
            document.dispatchEvent(new CustomEvent("ev-switch-toggled"));
        }

        if (this.props.valKey === "moduleInput") {

            window.apm.postEventToCurrentView({
                target: "request-update-member"
            });
        }

    }

    toggle(newVal){
        this.setState({checked: newVal});
    }

    /**
     * React render
     * @returns {XML}
     */
    render(){        
        return (
            <div className={"form-component-container"} style={{marginTop: "4px", display: "flex", alignItems: "center"}}>
                <div
                    className="form-component switch"
                    onClick={() => {
                        this.handleClick();
                    }}
                    >
                    <span className={"switch-toggle" + (this.state.checked ? " checked" : "") + (this.state.disabled ? " disabled" : "")}/>
                </div>
                <div
                    className="form-component switch-label"
                    style={{flex: '1'}}
                    onClick={() => {
                        this.handleClick();
                    }}
                    >{this.getLabel()}</div>
            </div>
        );
    }
}